import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { OptionType } from 'UIComponents/types/OptionTypes';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import BrowserTitle from 'data-token-picker/components/BrowserTitle';
import BrowserBody from 'data-token-picker/components/BrowserBody';
import BrowserFooter from 'data-token-picker/components/BrowserFooter';
import { TOKEN_INSERT, TOKEN_EDIT } from 'data-token-picker/constants/PickerModes';
import { useBrowserManagement } from '../hooks/useBrowserManagement';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PopoverContentPropTypes = {
  className: PropTypes.string,
  fallback: PropTypes.string,
  field: PropTypes.string,
  fieldsByCategory: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string,
    fieldType: PropTypes.string
  }))),
  allowEmptyFallbacks: PropTypes.bool,
  hideFallbacks: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  settingsLink: PropTypes.string,
  category: PropTypes.string,
  categories: PropTypes.arrayOf(OptionType.isRequired).isRequired,
  mode: PropTypes.oneOf([TOKEN_INSERT, TOKEN_EDIT])
};
const PopoverContent = props => {
  const {
    categories,
    className,
    mode = TOKEN_INSERT,
    onClose,
    onEditCategory,
    onEditField,
    settingsLink
  } = props;
  const {
    canSave,
    category,
    fieldReference,
    fieldsByCategory,
    handleConfirm,
    handleEdit,
    MaybeUserFallbackComponent,
    MaybeFallbackComponent
  } = useBrowserManagement(props);
  useEffect(() => {
    if (onEditCategory) onEditCategory(category);
  }, [category, onEditCategory]);
  useEffect(() => {
    if (onEditField) onEditField(fieldReference === null || fieldReference === void 0 ? void 0 : fieldReference.value);
  }, [fieldReference === null || fieldReference === void 0 ? void 0 : fieldReference.value, onEditField]);
  if (!category || !fieldsByCategory) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      className: "data-token-picker__body",
      layout: "centered",
      minHeight: 300
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(BrowserTitle, {
      mode: mode
    }), /*#__PURE__*/_jsx(BrowserBody, {
      category: category,
      categories: categories,
      field: fieldReference && fieldReference.value,
      fields: fieldsByCategory ? fieldsByCategory[category] : [],
      onEdit: handleEdit,
      settingsLink: settingsLink
    }), MaybeUserFallbackComponent, MaybeFallbackComponent, /*#__PURE__*/_jsx(BrowserFooter, {
      className: "m-top-5",
      disabled: !canSave,
      onConfirm: handleConfirm,
      onCancel: onClose
    })]
  });
};
PopoverContent.propTypes = PopoverContentPropTypes;
PopoverContent.displayName = 'PopoverContent';
export default PopoverContent;